'use client';

import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Countdown } from '@/components/Countdown';
import { ScHorizontalCountdown } from './styled';

interface IHorizontalCountdownProps {
  className?: string;
  timeLeft: number;
}

const ZERO_VALUE = '00';

export const HorizontalCountdown: FC<IHorizontalCountdownProps> = ({
  className,
  timeLeft,
}) => {
  const { t } = useTranslation();

  return (
    <ScHorizontalCountdown className={className}>
      <div className="label">{t('tournaments.endsIn')}</div>
      <div className="countdown">
        <Countdown dual timeLeft={Math.max(timeLeft, 0)}>
          {({ days, hours, minutes, seconds }) => (
            <>
              {days !== ZERO_VALUE && (
                <>
                  <span attr-label={t('timer.dd')}>{days}</span>:
                </>
              )}
              <span attr-label={t('timer.hh')}>{hours}</span>:
              <span attr-label={t('timer.mm')}>{minutes}</span>:
              <span attr-label={t('timer.ss')}>{seconds}</span>
            </>
          )}
        </Countdown>
      </div>
    </ScHorizontalCountdown>
  );
};
